import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 20 20\" id=\"icon-add\">\n  <path d=\"M11 9h4v2h-4v4H9v-4H5V9h4V5h2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol